/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_Total_RowInputs */

const en_cargos_sales_range_total_row = /** @type {(inputs: Cargos_Sales_Range_Total_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const es_cargos_sales_range_total_row = /** @type {(inputs: Cargos_Sales_Range_Total_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Cargos_Sales_Range_Total_RowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_total_row = /** @type {((inputs?: Cargos_Sales_Range_Total_RowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_Total_RowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_total_row(inputs)
	return es_cargos_sales_range_total_row(inputs)
});